import { Component, Inject, Input, OnDestroy, Optional } from '@angular/core';
import { Router } from '@angular/router';
import {
  CONFIG_MODAL_INPUTS_TOKEN,
  ModalOverlayRef,
} from '@core/classes/modal-overlay.ref';
import { LifePlanService } from '@core/services/life-plan.service';
import { UiService } from '@core/services/ui.service';
import { Subscription } from 'rxjs';
import { Insurance } from '../../core/constants/data-types.constants';
import { LifePlanManagerService } from '../../core/services/life-plan-manager.service';
import { LanguageService } from '../../i18n/services/language.service';
import * as actions from '@redux/actions';
import { AppState } from '../../redux/app.reducers';
import { Store } from '@ngrx/store';

@Component({
  selector: 'mfp-change-title',
  templateUrl: './change-title.component.html',
  styleUrls: ['./change-title.component.scss'],
})
export class ChangeTitleComponent implements OnDestroy {
  @Input() type = 'CREATE';
  @Input() lifePlanId = '';
  @Input() lifePlanTitle = '';
  @Input() title = '';
  @Input() productName = '';
  @Input() insurance: Insurance = 'DEATH';
  @Input() product = '';
  @Input() successAction = '';
  @Input() cancelAction = '';

  lifePlanTitleTouched = false;
  translation: any;
  clientId: string = '';

  private successCallback: any;
  private $languageSubscription: Subscription;
  private $storeSubscription: Subscription;

  constructor(
    public dialogRef: ModalOverlayRef,
    private uiService: UiService,
    private router: Router,
    private language: LanguageService,
    private store: Store<AppState>,
    private lifePlanService: LifePlanService,
    private lifePlanManager: LifePlanManagerService,
    @Optional() @Inject(CONFIG_MODAL_INPUTS_TOKEN) config: any
  ) {
    if (config) {
      this.type = config.type;
      this.title = config.title;
      this.productName = config.productName;
      this.insurance = config.insurance;
      this.product = config.product;
      this.lifePlanId = config.lifePlanId;
      this.lifePlanTitle = config.lifePlanTitle;
      this.successAction = config.successAction;
      this.cancelAction = config.cancelAction;
      this.successCallback = config.successCallback;
    }
    this.$languageSubscription = this.language.stream('LIFE_PLANS').subscribe({
      next: (translation) => {
        this.translation = translation;
      },
    });
    this.$storeSubscription = this.store.subscribe({
      next: (state) => {
        this.clientId = state.clientData.clientId;
      },
    });
  }

  ngOnDestroy() {
    this.$languageSubscription.unsubscribe();
    this.$storeSubscription.unsubscribe();
  }

  onClose() {
    this.dialogRef.close();
  }

  onAccept() {
    if (this.lifePlanTitle) {
      this.onCreateLifePlan(this.lifePlanTitle);
    } else {
      this.lifePlanTitleTouched = true;
    }
  }

  onChangeTitle(title: string) {
    this.lifePlanTitleTouched = true;
    this.lifePlanTitle = title;
  }

  private onCreateLifePlan(newLifePlanTitle?: string) {
    this.uiService.presentLoading(this.translation.LOADINGS.CREATE);
    this.lifePlanManager
      .createAndManageAgentLifePlan({
        title: newLifePlanTitle,
        type: 'COMPLETE',
        status: 'DRAFT',
        clientId: this.clientId,
      })
      .subscribe({
        next: (lifePlan) => {
          this.onClose();
          this.router.navigate([`/agent/life-plans/${lifePlan.id}/form/`]);
        },
        error: (error) => {
          this.onClose();
          this.uiService.dismissLoading();
          this.uiService.openErrorModal();
        },
        complete: () => this.uiService.dismissLoading(),
      });
  }
}
